import { Article } from "../types/articles";

export function publishToOrderModal(
  article: Article,
  itemOrigin: string,
  productRecoModel: string,
  pageLocation: string
): void {
  if (shell) {
    shell.messageBroker.publishTo("ESPP.OrderModal.Open", {
      colorCode: article.colorCode,
      itemOrigin: itemOrigin,
      masterArticleNo: article.masterArticleNo,
      salesArticleNo: article.salesArticleNo,
      sizeCode: article.sizeCode,
      semanticId: "product-recommendation-tile",
      productRecommendationTileIndex: article.slot,
      productRecommendationFragment: `product-recommendation-${pageLocation}`,
      productRecommendationModel: productRecoModel
    });
  }
}
